export const frPackagedOrders = {
    'packagedOrders.type.offer': 'Bon plan',
    'packagedOrders.type.tunable': 'Libre',

    // PACKAGED ORDERS

    'packagedOrders.title': 'Bons Plans',
    'packagedOrders.list.pageTitle': 'Bons Plans',
    'packagedOrders.list.sectionTitle': 'Bons plans',
    'packagedOrders.list.emptyLabel': 'Aucun bon plan pour le moment.',
    'packagedOrders.list.actions.addPackagedOrder': 'Créer un bon plan',
    'packagedOrders.list.actions.addTunableOffer': 'Créer un bon plan libre',
    'packagedOrders.list.actions.synchronisePackagedOrders': 'Synchroniser les bons plans',
    'packagedOrders.list.table.emptyLabel': "Il n'y a pas de bon plan pour le moment.",
    'packagedOrders.list.table.header.info': 'Informations',
    'packagedOrders.list.table.header.owner': 'Propriétaire',
    'packagedOrders.list.table.header.nbShops': 'Nombre de centres',
    'packagedOrders.list.table.header.endDate': "Date d'échéance",
    'packagedOrders.list.table.header.type': 'Type',
    'packagedOrders.list.table.state.draft': 'Brouillon',
    'packagedOrders.list.table.state.drafts': 'Brouillon',
    'packagedOrders.list.table.state.published': 'Publié',
    'packagedOrders.list.table.state.unpublished': 'Annulé',
    'packagedOrders.list.table.state.finished': 'Terminé',
    'packagedOrders.list.table.filters.favoriteShops': 'Mes centres favoris',
    'packagedOrders.list.table.filters.apply': 'Appliquer',
    'packagedOrders.list.table.filters.label.state': 'État :',
    'packagedOrders.list.popup.title': 'Synchronisation des bons plans',
    'packagedOrders.list.popup.pleaseWait': 'Merci de patienter durant la synchronisation',

    // PACKAGED CREATE

    'packagedOrders.create.pageTitle': 'Création bon plan',
    'packagedOrders.create.actions.cancelCreation': 'Annuler la création',
    'packagedOrders.create.actions.addThePackagedOrder': 'Enregistrer',
    'packagedOrders.create.input.name': 'Saisissez ici le nom du bon plan *',
    'packagedOrders.create.input.code': 'Saisissez ici le code du bon plan',
    'packagedOrders.input.title.label': 'Nom',
    'packagedOrders.input.code.label': 'Code',
    'packagedOrders.create.tabs.info': 'Informations',
    'packagedOrders.create.tabs.audience': 'Audience',
    'packagedOrders.create.tabs.notifications': 'Notifications',
    'packagedOrders.create.tabs.audiences.treeTitle': 'Choix sectorisation',
    'packagedOrders.create.tabs.audiences.btnLabel': "Définir l'audience à partir d'une question",
    'packagedOrders.create.tabs.audiences.dialog.title':
        "Définir l'audience à partir d'une question",
    'packagedOrders.create.tabs.audiences.dialog.floatingLabel': 'Code question',
    'packagedOrders.create.tabs.audiences.dialog.hintLabel': 'Référence de la réponse concernée',
    'packagedOrders.create.tabs.audiences.dialog.cancelLabel': 'Annuler',
    'packagedOrders.create.tabs.audiences.dialog.validateLabel': 'Valider',
    'packagedOrders.create.tabs.informations.generalSectionTitle': 'Informations générales',
    'packagedOrders.create.tabs.informations.type': 'Fixe',
    'packagedOrders.create.tabs.informations.publishSectionTitle': 'Publication',
    'packagedOrders.create.tabs.informations.inputs.floatingLabelEndDate': "Date d'échéance",
    'packagedOrders.create.tabs.informations.inputs.endDate': "Sélectionnez une date d'échéance",
    'packagedOrders.info.description': 'Saisissez ici la description du bon plan',
    'packagedOrders.create.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'packagedOrders.info.price': 'Saisissez ici le prix du bon plan',
    'packagedOrders.info.price.label': 'Prix unitaire (€)',
    'packagedOrders.info.totalNb': 'Saisissez ici le nombre total de palettes',
    'packagedOrders.info.totalNb.label': 'Nombre total de palettes',
    'packagedOrders.create.tabs.informations.inputs.remaningCount':
        'Saisissez ici le stock Restant',
    'packagedOrders.create.tabs.informations.inputs.floatingLabelRemaningCount': 'Stock Restant',
    'packagedOrders.create.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'packagedOrders.create.tabs.informations.select.owner.title':
        'Sélectionnez le propriètre du bon plan',
    'packagedOrders.create.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'packagedOrders.create.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'packagedOrders.create.tabs.informations.select.owner.listInputLabel':
        'Chercher un utilisateur siège',
    'packagedOrders.create.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'packagedOrders.create.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'packagedOrders.create.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'packagedOrders.create.tabs.informations.select.docs.title': 'Joindre un fichier PDF',
    'packagedOrders.create.tabs.informations.select.docs.label': 'Fichier PDF',
    'packagedOrders.create.tabs.informations.select.docs.btn': 'Parcourir',
    'packagedOrders.create.tabs.informations.select.docs.imageUrl': "URL de l'image",
    'packagedOrders.create.tabs.informations.select.docs.load': 'Charger',
    'packagedOrders.create.tabs.informations.select.docs.hintHttp': 'http://...',
    'packagedOrders.create.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'packagedOrders.create.tabs.informations.publish.publishBtn': 'Publier',
    'packagedOrders.create.tabs.informations.publish.cancelBtn': 'Annuler la publication',
    'packagedOrders.create.tabs.notifs.time': '--',
    'packagedOrders.create.tabs.notifs.floatingLabelTime': 'Heure de la relance',
    'packagedOrders.create.tabs.notifs.date': '--',
    'packagedOrders.create.tabs.notifs.floatingLabelDate': 'Date de la relance',
    'packagedOrders.create.tabs.notifs.dateSwitch': 'Date unique',
    'packagedOrders.create.tabs.notifs.recursiveTime': '--',
    'packagedOrders.create.tabs.notifs.floatingLabelRecursiveTime': 'Heure de répétition',
    'packagedOrders.create.tabs.notifs.recursiveTimeSwitch': 'Répétition',
    'packagedOrders.create.tabs.notifs.repeat': '--',
    'packagedOrders.create.tabs.notifs.floatingLabelRepeat': 'Tous les XX jours',
    'packagedOrders.create.tabs.notifs.noneLabel': 'Aucune relance',
    'packagedOrders.create.tabs.notifs.autoSend': 'Relance automatique',

    // PACKAGED DETAILS

    'packagedOrders.details.pageTitle': 'Détails bon plan',
    'packagedOrders.details.input.name': 'Saisissez ici le nom du bon plan *',
    'packagedOrders.details.input.code': 'Saisissez ici le code du bon plan',
    'packagedOrders.details.input.floatingLabelName': 'Nom',
    'packagedOrders.details.input.floatingLabelCode': 'Code',
    'packagedOrders.details.dialog.title': 'Suppression du bon plan',
    'packagedOrders.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce bon plan ?',
    'packagedOrders.details.dialog.validateLabel': 'Supprimer',
    'packagedOrders.details.dialog.cancelLabel': 'Annuler',

    'packagedOrders.clone.dialog.title': 'Copie du bon plan',
    'packagedOrders.clone.dialog.content': 'Voulez-vous créer une copie de ce Bon plan ?',

    'packagedOrders.details.actions.save': 'Enregistrer',
    'packagedOrders.details.actions.remove': 'Supprimer',
    'packagedOrders.details.actions.previous': 'Bons plans',
    'packagedOrders.details.tabs.info': 'Informations',
    'packagedOrders.details.tabs.details': 'Détails',
    'packagedOrders.details.tabs.results': 'Résultats',
    'packagedOrders.details.tabs.audience': 'Audience',
    'packagedOrders.details.tabs.notifications': 'Notifications',
    'packagedOrders.details.tabs.informations.generalSectionTitle': 'Informations générales',
    'packagedOrders.details.tabs.informations.type': 'Fixe',
    'packagedOrders.details.tabs.informations.publishSectionTitle': 'Publication',
    'packagedOrders.details.tabs.informations.inputs.floatingLabelEndDate': "Date d'échéance",
    'packagedOrders.details.tabs.informations.inputs.endDate': "Sélectionnez une date d'échéance",
    'packagedOrders.info.shipmentDate': 'Saisissez ici la semaine de livraison du bon plan',
    'packagedOrders.info.shipmentDate.label': 'Semaine de livraison',
    'packagedOrders.details.tabs.informations.inputs.description':
        'Saisissez ici la description du bon plan',
    'packagedOrders.details.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'packagedOrders.details.tabs.informations.inputs.price': 'Saisissez ici le prix du bon plan',
    'packagedOrders.details.tabs.informations.inputs.floatingLabelPrice': 'Prix unitaire (€)',
    'packagedOrders.details.tabs.informations.inputs.totalNb':
        'Saisissez ici le nombre total de palettes',
    'packagedOrders.details.tabs.informations.inputs.floatingLabelRemaningCount': 'Stock restant',
    'packagedOrders.details.tabs.informations.inputs.remaningCount':
        'Saisie manuelle du stock Restant',
    'packagedOrders.details.tabs.informations.inputs.floatingLabelRemaning': 'Stock',
    'packagedOrders.details.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'packagedOrders.details.tabs.informations.select.owner.title':
        'Sélectionnez le propriètre du bon plan',
    'packagedOrders.details.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'packagedOrders.details.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'packagedOrders.details.tabs.informations.select.owner.listInputLabel':
        'Chercher un utilisateur siège',
    'packagedOrders.details.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'packagedOrders.details.tabs.informations.select.docs.defaultDocumentName': 'Document PDF',
    'packagedOrders.details.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'packagedOrders.details.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'packagedOrders.details.tabs.informations.select.docs.title': 'Joindre un fichier PDF',
    'packagedOrders.details.tabs.informations.select.docs.label': 'Fichier PDF',
    'packagedOrders.details.tabs.informations.select.docs.btn': 'Parcourir',
    'packagedOrders.details.tabs.informations.select.docs.imageUrl': "URL de l'image",
    'packagedOrders.details.tabs.informations.select.docs.load': 'Charger',
    'packagedOrders.details.tabs.informations.select.docs.hintHttp': 'http://...',
    'packagedOrders.details.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'packagedOrders.details.tabs.informations.select.publisher.sectionTitle': 'Publier en tant que',
    'packagedOrders.details.tabs.informations.select.publisher.title':
        'Sélectionnez le nom du publieur',
    'packagedOrders.details.tabs.informations.select.publisher.floatingLabelTitle':
        'Publier en tant que',
    'packagedOrders.details.tabs.informations.select.publisher.listTitle': 'Choix du publieur',
    'packagedOrders.details.tabs.informations.select.publisher.listInputLabel':
        'Chercher un utilisateur ou une équipe',
    'packagedOrders.details.tabs.informations.select.publisher.listCloseLabel': 'Fermer',
    'packagedOrders.details.tabs.informations.publish.publishBtn': 'Publier',
    'packagedOrders.details.tabs.informations.publish.cancelBtn': 'Annuler la publication',
    'packagedOrders.details.tabs.audiences.treeTitle': 'Choix sectorisation',
    'packagedOrders.audiences.btnLabel': "Définir l'audience à partir d'une question",
    'packagedOrders.audiences.dialog.title': "Définir l'audience à partir d'une question",
    'packagedOrders.audiences.dialog.label': 'Code question',
    'packagedOrders.audiences.dialog.hint': 'Référence de la réponse concernée',
    'packagedOrders.details.tabs.audiences.dialog.cancelLabel': 'Annuler',
    'packagedOrders.details.tabs.audiences.dialog.validateLabel': 'Valider',
    'commons.products.list.empty': 'Aucun produit pour le moment.',
    'packagedOrders.details.tabs.details.actions.import': 'Import Excel',
    'packagedOrders.details.tabs.details.actions.export': 'Export Excel',
    'packagedOrders.products.actions.delete_all': 'Tout supprimer',
    'packagedOrders.products.actions.add': 'Ajouter un produit',
    'packagedOrders.product.quantity': 'Quantité',
    'packagedOrders.product.price': 'Prix: ',
    'packagedOrders.product.margin': 'Tx marge: ',
    'packagedOrders.product.discountPrice': 'Prix promo: ',
    'packagedOrders.product.discountMargin': 'Tx marge promo: ',

    'packagedOrders.product.multiPrice.normal_bought_price': 'PA:',
    'packagedOrders.product.multiPrice.normal_sell_price': 'PVC:',
    'packagedOrders.product.multiPrice.promo_bought_price': 'PA Promo:',
    'packagedOrders.product.multiPrice.promo_sell_price': 'PVC promo:',

    'packagedOrders.product.multiPrice.promo_odr_price': 'Après ODR:',
    'packagedOrders.product.remove.dialog.title': "Suppression d'un produit",
    'packagedOrders.product.remove.dialog.content':
        'Êtes-vous sûr de vouloir supprimer ce produit ?',
    'packagedOrders.product.remove.all.dialog.title': 'Suppression de tous les produits',
    'packagedOrders.product.remove.all.dialog.content':
        'Êtes-vous sûr de vouloir supprimer tous les produits ?',
    'packagedOrders.details.tabs.details.dialog.validateLabel': 'Supprimer',
    'packagedOrders.details.tabs.details.dialog.cancelLabel': 'Annuler',
    'commons.product.dialog.addTitle': 'Ajouter un produit',
    'commons.product.dialog.editTitle': 'Éditer un produit',
    'packagedOrders.product.dialog.cancel': 'Annuler',
    'packagedOrders.product.dialog.save': 'Enregistrer',
    'packagedOrders.product.dialog.create': 'Créer',
    'packagedOrders.product.dialog.name.label': 'Nom',
    'packagedOrders.product.dialog.inputs.description': 'Description',
    'packagedOrders.product.dialog.quantity.label': 'Quantité',
    'packagedOrders.product.dialog.inputs.ref': 'Référence',
    'packagedOrders.product.dialog.inputs.unitPrice': 'Prix unitaire',
    'packagedOrders.product.dialog.margin.label': 'Taux de marge',
    'packagedOrders.product.dialog.discountUnitPrice.label': 'Prix unitaire promo',
    'packagedOrders.product.dialog.discountMargin.label': 'Taux de marge promo',
    'packagedOrders.product.dialog.name': 'Titre du produit *',
    'packagedOrders.product.dialog.description': 'Description du produit',
    'packagedOrders.product.dialog.quantity': 'Nombre de produits',
    'packagedOrders.product.dialog.inputs.hints.ref': 'Référence du produit *',
    'packagedOrders.product.dialog.inputs.hints.unitPrice': 'Prix en euros',
    'packagedOrders.product.dialog.margin': 'Pourcentage de marge',
    'packagedOrders.product.dialog.discountUnitPrice': 'Prix promo en euros',
    'packagedOrders.product.dialog.discountMargin': 'Pourcentage après promo',
    'packagedOrders.product.dialog.inputs.error': 'invalide',

    'packagedOrders.product.dialog.multiPrice.normal_bought_price.label': 'PA',
    'packagedOrders.product.dialog.multiPrice.normal_sell_price.label': 'PVC',
    'packagedOrders.product.dialog.multiPrice.promo_bought_price.label': 'PA Promo',
    'packagedOrders.product.dialog.multiPrice.promo_sell_price.label': 'PVC promo',

    'packagedOrders.product.dialog.multiPrice.normal_bought_price': "Prix d'achat en euros",
    'packagedOrders.product.dialog.multiPrice.normal_sell_price':
        'Prix de vente conseillée en euros',
    'packagedOrders.product.dialog.multiPrice.promo_bought_price': "Prix d'achat promo en euros",
    'packagedOrders.product.dialog.multiPrice.promo_sell_price':
        'Prix de vente conseillé promo en euros',

    'packagedOrders.product.dialog.multiPrice.promo_odr_price.label': 'Après ODR',
    'packagedOrders.product.dialog.multiPrice.promo_odr_price':
        'Prix de vente conseillé après ODR en euros',

    'packagedOrders.product.dialog.addPhoto.or': 'OU',

    'packagedOrders.details.tabs.notifs.time': '--',
    'packagedOrders.details.tabs.notifs.floatingLabelTime': 'Heure de la relance',
    'packagedOrders.details.tabs.notifs.date': '--',
    'packagedOrders.details.tabs.notifs.floatingLabelDate': 'Date de la relance',
    'packagedOrders.details.tabs.notifs.dateSwitch': 'Date unique',
    'packagedOrders.details.tabs.notifs.recursiveTime': '--',
    'packagedOrders.details.tabs.notifs.floatingLabelRecursiveTime': 'Heure de répétition',
    'packagedOrders.details.tabs.notifs.recursiveTimeSwitch': 'Répétition',
    'packagedOrders.details.tabs.notifs.repeat': '--',
    'packagedOrders.details.tabs.notifs.floatingLabelRepeat': 'Tous les XX jours',
    'packagedOrders.details.tabs.notifs.noneLabel': 'Aucune relance',
    'packagedOrders.details.tabs.notifs.autoSend': 'Relance automatique',
    'packagedOrders.details.tabs.notifs.manualSend': 'Relance manuelle',
    'packagedOrders.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté le bon plan",
    'packagedOrders.details.tabs.notifs.manualBtnlabel': 'Relancer',
    'packagedOrders.details.tabs.notifs.notifsHistoryEmpty': "Pas d'historique de notifications",
    'packagedOrders.details.tabs.notifs.tableTitle': 'Historique des notifications',
    'packagedOrders.details.tabs.results.sectionTitle': 'Résultats',
    'packagedOrders.details.tabs.results.export': 'Export Excel',
    'packagedOrders.details.tabs.results.totalPriceOrderedLabel': 'Total commandé:',
    'packagedOrders.details.tabs.results.orderedShopCountLabel': 'Réponses:',
    'packagedOrders.details.tabs.results.orderedShopCountValue': '{ordered_shop_count} centres / {shop_count}',
    'packagedOrders.details.tabs.results.tableHeader.shop': 'Centre',
    'packagedOrders.details.tabs.results.tableHeader.shops': 'Centres',
    'packagedOrders.details.tabs.results.tableHeader.user': 'Utilisateur',
    'packagedOrders.details.tabs.results.tableHeader.answerDate': 'Date de réponse',
    'packagedOrders.details.tabs.results.tableHeader.orderedQuantity': 'Quantité commandée',
    'packagedOrders.details.tabs.results.tableHeader.totalQuantity': 'Total commandé',
    'packagedOrders.details.tabs.results.tableHeader.action': 'Détail commandé',
    'packagedOrders.details.tabs.results.tableRow.action': 'Visualiser la commande',
    'packagedOrders.details.tabs.results.emptyLabel': 'Aucun résultat pour le moment.',
    'packagedOrders.details.tabs.results.detailDialog.title': 'Commande du centre {name}',
    'packagedOrders.details.tabs.results.detailDialog.titleLoading': 'Chargement de la commande...',
    'packagedOrders.details.tabs.results.detailDialog.header.detail': 'Détail produit',
    'packagedOrders.details.tabs.results.detailDialog.header.quantity': 'Quantité',
    'packagedOrders.details.tabs.results.detailDialog.messages.error':
        'Erreur de chargement. Veillez réessayer',
    'packagedOrders.details.tabs.results.detailDialog.messages.no_items': 'Aucun produit commandé',
    'packagedOrders.details.tabs.results.detailDialog.footer.quantity': 'TOTAL DE LA COMMANDE',

    //TOAST ERRORS
    'toast.apiErrors.PACKAGED_ORDER_MISSING_NOTIFICATION_CONFIGURATION':
        "Veuillez configurer l'envoi des notification avant d'effectuer cette opération.",
    'toast.apiErrors.PACKAGED_ORDER_NOT_PUBLISHED':
        "Cette opération ne peut s'effectuer que sur une offre publiée",
    'toast.apiErrors.PACKAGED_ORDER_CANT_DELETE_PUBLISHED':
        'Impossible de supprimer un bon plan qui a été publié',
    'toast.apiErrors.PACKAGED_ORDER_ALREADY_PUBLISHED': 'Ce bon plan est déjà publié',
    'toast.apiErrors.PACKAGED_ORDER_MISSING_END_DATE':
        "La date d'échéance n'est pas définie pour ce bon plan, il ne peut pas être publié",
    'toast.apiErrors.PACKAGED_ORDER_MISSING_UNIT_PRICE':
        "Le prix unitaire n'est pas défini pour ce bon plan, il ne peut pas être publié",
    'toast.apiErrors.PACKAGED_ORDER_MISSING_PRODUCT':
        'Le bon plan doit contenir au moins un produit',
    'toast.apiErrors.PACKAGED_ORDER_PRODUCT_MISSING_PURCHASE_PRICE':
        "Le prix d'achat doit être défini pour chaque produit",
    'toast.apiErrors.PACKAGED_ORDER_PRODUCT_MISSING_PURCHASE_PRICE_PROMO':
        "Le prix d'achat promo doit être défini pour chaque produit",
    'toast.apiErrors.PACKAGED_ORDER_PRODUCT_MISSING_MARGIN_RATE':
        'Le taux de marge doit être défini pour chaque produit',
    'toast.apiErrors.PACKAGED_ORDER_PRODUCT_MISSING_MARGIN_RATE_PROMO':
        'Le taux de marge promo doit être défini pour chaque produit',
    'toast.apiErrors.PACKAGED_ORDER_PRODUCT_MISSING_QUANTITY':
        'La quantité doit être définie pour chaque produit',
    'toast.apiErrors.PACKAGED_ORDER_PUBLISHED_CANT_ADD_PRODUCT':
        "Impossible d'ajouter un nouveau produit sur un bon plan qui a été publié",
    'toast.apiErrors.PACKAGED_ORDER_PUBLISHED_CANT_EDIT_PRODUCT':
        "Impossible de modifier la référence, le prix d'achat promo ou la quantité d'un produit sur un bon plan qui a déjà été publié",
    'toast.apiErrors.PACKAGED_ORDER_PUBLISHED_CANT_DELETE_PRODUCT':
        'Impossible de supprimer un produit existant sur un bon plan qui a été publié',
    'toast.apiErrors.PACKAGED_ORDER_ALREADY_UNPUBLISHED':
        'Ce bon plan est déjà au statut publication annulée',
    'toast.apiErrors.PACKAGED_ORDER_MISSING_AUDIENCE':
        "Aucune audience n'est définie pour ce bon plan, il ne peut pas être publié",
    'toast.apiErrors.PACKAGED_ORDER_PUBLISHED_CANT_EDIT':
        'Ce bon plan est publié, le prix unitaire ne sont plus modifiables',
};
